import React from 'react';
import { AlertCircle, X, Loader2 } from 'lucide-react';

export default function ConfirmModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = '确认操作', 
  message, 
  confirmText = '确定', 
  cancelText = '取消',
  confirmStyle = 'primary', // primary, danger, success
  loading = false,
  children
}) {
  if (!isOpen) return null;

  const getConfirmButtonClass = () => {
    switch (confirmStyle) {
      case 'danger':
        return 'bg-red-600 hover:bg-red-700 focus:ring-red-500';
      case 'success':
        return 'bg-green-600 hover:bg-green-700 focus:ring-green-500';
      case 'primary':
      default:
        return 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500';
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 pt-4 pb-20 text-center sm:p-0">
      <div 
        className="fixed inset-0 transition-opacity bg-gray-900/75 dark:bg-gray-900/90 backdrop-blur-sm" 
        onClick={!loading ? onClose : undefined}
      />

      <div className="relative inline-block w-full max-w-lg px-4 pt-5 pb-4 overflow-visible text-left align-bottom transition-all transform bg-white dark:bg-gray-800 rounded-2xl shadow-xl sm:my-8 sm:p-6 sm:align-middle animate-in fade-in zoom-in duration-200">
        <div className="absolute top-0 right-0 pt-4 pr-4">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 focus:outline-none"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="sm:flex sm:items-start">
          <div className={`flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto rounded-full sm:mx-0 sm:h-10 sm:w-10 ${
            confirmStyle === 'danger' ? 'bg-red-100 dark:bg-red-900/30' : 
            confirmStyle === 'success' ? 'bg-green-100 dark:bg-green-900/30' : 
            'bg-blue-100 dark:bg-blue-900/30'
          }`}>
            <AlertCircle className={`w-6 h-6 ${
              confirmStyle === 'danger' ? 'text-red-600 dark:text-red-400' : 
              confirmStyle === 'success' ? 'text-green-600 dark:text-green-400' : 
              'text-blue-600 dark:text-blue-400'
            }`} />
          </div>
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
            <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">
              {title}
            </h3>
            <div className="mt-2">
              {message && (
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {message}
                </p>
              )}
              {children}
            </div>
          </div>
        </div>
        
        <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-3">
          <button
            type="button"
            disabled={loading}
            onClick={onConfirm}
            className={`w-full inline-flex justify-center rounded-xl border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm transition-colors ${getConfirmButtonClass()} disabled:opacity-50`}
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : confirmText}
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={onClose}
            className="mt-3 w-full inline-flex justify-center rounded-xl border border-gray-300 dark:border-gray-600 px-4 py-2 bg-white dark:bg-gray-800 text-base font-medium text-gray-700 dark:text-gray-300 shadow-sm hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm transition-colors disabled:opacity-50"
          >
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
}